module.exports = __webpack_public_path__ + "img/todos.ba6b3444.svg";